import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import { AccordionSummary, AccordionDetails, Typography } from "@mui/material";

interface AccordionPropsType {
    id?: number,
    question?: string,
    answer?: string,
}

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid #000`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

export default function CustomAccordion(props: AccordionPropsType) {

    const [ expanded, setExpanded ] = useState<boolean>(false);

    const handleAccordionChange = () => {
        setExpanded(!expanded);
    };

    return (
        <Accordion expanded={expanded} onChange={handleAccordionChange}>
            <AccordionSummary
                expandIcon={expanded ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{ backgroundColor: expanded ? "#E0E7EC" : "#fff" }}
            >
                <Typography variant="h4">{`Q. ${props.question}`}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: expanded ? "#E0E7EC" : "#fff" }}>
                <Typography>{`A: ${props.answer}`}</Typography>
            </AccordionDetails>
        </Accordion>
    )
}
